<template>
  <t-form labelWidth="80px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <e-collapse title="基础设置" :expand="true">
      <t-form-item label="宽度">
        <t-input-number
          size="small"
          :min="0"
          :max="9999"
          v-model="currentCpt.cptWidth"
          :decimal-places="0"
        />
      </t-form-item>
      <t-form-item label="高度">
        <t-input-number
          size="small"
          :min="0"
          :max="9999"
          v-model="currentCpt.cptHeight"
          :decimal-places="0"
        />
      </t-form-item>
      <t-form-item label="背景颜色">
        <t-color-picker
          size="small"
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.bgColor"
        />
      </t-form-item>
      <t-form-item label="二维码颜色">
        <t-color-picker
          size="small"
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.qrColor"
        />
      </t-form-item>
      <t-tooltip content="错误纠正级别，从低到高有 L、M、Q、H 四种">
        <t-form-item label="等级">
          <t-radio-group size="small" v-model="attribute.qrLevel">
            <t-radio-button value="L">L</t-radio-button>
            <t-radio-button value="M">M</t-radio-button>
            <t-radio-button value="Q">Q</t-radio-button>
            <t-radio-button value="H">H</t-radio-button>
          </t-radio-group>
        </t-form-item>
      </t-tooltip>
    </e-collapse>
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
export default {
  name: "cpt-qrcode-option",
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
  },
  components: { CptData },
};
</script>

<style>
</style>